module.exports = __webpack_public_path__ + "static/media/hot_mmcj.27d740cd.png";